import { AxiosResponse } from "axios";
import API from "../api";
import { AccessSettings } from "../models/access.settings";
import { PdfReport } from "../models/pdf.report";
import BaseService from "./_base.service";
import { MapCell } from "../models/warehouse.mapcell";
import { Warehouse } from "../models/warehouse";
import { StorageBoxType } from "../models/storage.box.type";
import { StorageBox } from "../models/storage.box";
import { User } from "../models/user";
import { TypeReportWarehouse } from "../util/enums";

const endpoint = "warehouse/reports";

export interface MovementsReportCSV {
  "Storage box type": string;
  "Object number": string;
  From: string;
  To: string;
  When: string;
  "By whom": string;
}

export interface MovementsReportCSVData {
  movementsCSVData: MovementsReportCSV[];
}

export interface LocationStatusReportCSV {
  Warehouse: string;
  "Storage box type": string;
  "Storage box number": string;
  Location: string;
  Order: string;
  Status: string;
}

export interface LocationStatusReportCSVData {
  locationStatusCSVData: LocationStatusReportCSV[];
}

export interface StorageBoxStatusOption {
  id: number;
  valid: boolean;
  name: string;
  storageBoxes?: StorageBox[];
}

export interface GenerateWarehouse {
  type: TypeReportWarehouse;
  warehouses?: Warehouse[];
  storageBoxTypes?: StorageBoxType[];
  storageBoxes?: StorageBox[];
  drivers?: User[];
  storageBoxStatuses?: StorageBoxStatusOption[];
  startDate?: string;
  endDate?: string;
  mapCells?: MapCell[];
  status?: Array<"In Use" | "Empty">;
  limit?: number;
}

const WarehouseReportService = {
  ...BaseService<AccessSettings>({ endpoint }),
  async generate(generate: GenerateWarehouse): Promise<AxiosResponse<PdfReport>> {
    return await API.post(`/${endpoint}/generate`, generate);
  },
  async getLocationsStatusReports(
    generateFilters?: GenerateWarehouse,
    options?: any
  ): Promise<AxiosResponse<any>> {
    return await API.post(`/${endpoint}/location/status`, generateFilters, { params: options });
  },
  async getMovementsReports(
    generateFilters?: GenerateWarehouse,
    options?: any
  ): Promise<AxiosResponse<any>> {
    return await API.post(`/${endpoint}/movements`, generateFilters, { params: options });
  },
  async getLocationStatusExportCSVData(exportFilters?: GenerateWarehouse): Promise<AxiosResponse<LocationStatusReportCSVData>> {
    return await API.post(`/${endpoint}/location/status/export`, exportFilters);
  },
  async getMovementsExportCSVData(exportFilters?: GenerateWarehouse): Promise<AxiosResponse<MovementsReportCSVData>> {
    return await API.post(`/${endpoint}/movements/export`, exportFilters);
  }
};

export default WarehouseReportService;
